import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "eauveo_admin_token";

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Une erreur est survenue. Merci de réessayer.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const adminApi = axios.create({ baseURL: `${API}/admin` });
adminApi.interceptors.request.use((c) => {
  const t = getToken();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const ORDER_STATUS = {
  en_attente_paiement: ["En attente de paiement", "bg-slate-100 text-slate-700"],
  payee: ["Payée", "bg-emerald-100 text-emerald-800"],
  expediee: ["Expédiée", "bg-sky-100 text-sky-800"],
  livree: ["Livrée", "bg-indigo-100 text-indigo-800"],
  annulee: ["Annulée", "bg-orange-100 text-orange-800"],
  abandonnee: ["Abandonnée", "bg-zinc-200 text-zinc-700"],
  partiellement_remboursee: ["Partiellement remboursée", "bg-rose-100 text-rose-800"],
  remboursee: ["Remboursée", "bg-rose-200 text-rose-900"],
};

export const fmtDate = (iso) =>
  iso ? new Intl.DateTimeFormat("fr-FR", { timeZone: "Europe/Paris", dateStyle: "short", timeStyle: "short" }).format(new Date(iso)) : "—";

export const EMAIL_KIND = {
  client_confirmation: "Confirmation client",
  vendeur_notification: "Notif. vendeur (commande)",
  vendeur_rappel: "Notif. vendeur (rappel)",
  invitation_avis: "Invitation avis",
  relance_1: "Relance panier #1",
  relance_2: "Relance panier #2",
  expedition: "Expédition",
  bilan_soir: "Bilan du soir",
  bilan_hebdo: "Bilan hebdomadaire",
  remboursement: "Remboursement",
  reinitialisation_mdp: "Réinitialisation mot de passe",
};

const EVENT = {
  delivered: ["Remis", "bg-emerald-100 text-emerald-800"],
  opened: ["Ouvert", "bg-emerald-100 text-emerald-800"],
  clicked: ["Cliqué", "bg-emerald-100 text-emerald-800"],
  delivery_delayed: ["Retardé", "bg-amber-100 text-amber-800"],
  bounced: ["Rejeté", "bg-red-100 text-red-800"],
  complained: ["Spam (plainte)", "bg-red-100 text-red-800"],
  failed: ["Échec", "bg-red-100 text-red-800"],
};

export const emailStatus = (l) => (l.ok === false ? EVENT.failed : EVENT[l.last_event] || ["Envoyé", "bg-sky-100 text-sky-800"]);
